import type { QueryClient } from "@tanstack/react-query";
import { unscopedKey } from "@/lib/queryClient";

/** Refresh identity and the host/viewer-partitioned team directory after an
 * authenticated account accepts either kind of access-granting invite. */
export async function invalidateInviteAcceptanceCaches(
  queryClient: QueryClient,
): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: unscopedKey("me") }),
    queryClient.invalidateQueries({
      queryKey: unscopedKey("accessible-teams"),
    }),
  ]);
}
